/**
 * Copyright (c) 2015-present, JD.com All rights reserved.
 *
 * @providesModule JDConfirmDialog
 * 
 */
'use strict';

const PropTypes = require('prop-types');

const React = require('react');
const {
  View,
  StyleSheet,
  Platform
} = require('react-native');
import {
    JDDialog,
    JDText,
    JDDevice,
    JDTouchable,
} from '@jdreact/jdreact-core-lib';
class JDConfirmDialog extends React.Component {
  static propTypes = {
    ...JDDialog.propTypes,

    /**
     * 点击确定的回调方法
     */
    onConfirm: PropTypes.func,

    /**
     * 确定按钮的文本
     */
    confirmText: PropTypes.string,

    /**
     * 确定按钮按下去是按钮的背景色
     */
    confirmUnderlayColor: PropTypes.string,

    /**
     * 点击取消按钮的回调
     */
    onCancel: PropTypes.func,

    /**
     * 确定按钮的样式
     */
    confirmStyle: PropTypes.oneOfType([PropTypes.number, PropTypes.object, PropTypes.array]),

    /**
     * 取消按钮的文本
     */
    cancelText: PropTypes.string,

    /**
     * 取消按钮按下去是按钮的背景色
     */
    cancelUnderlayColor: PropTypes.string,

    /**
     * 取消按钮的样式
     */
    cancelStyle: PropTypes.any,

    /**
     * 安卓dialog在获取焦点时，是否要向上平移对话框
     */
    onFocusUp: PropTypes.bool,
    /**
    * dialog隐藏之后的回调
    */
    onDismiss: PropTypes.func,
    /**
     * 安卓modal消失时，是否触发onDismiss回调
     */
    dismiss: PropTypes.bool
  };
  static defaultProps = {
    show: false,
    cancelText: '取消',
    confirmUnderlayColor: '#F23030',
    cancelUnderlayColor: null,
    onFocusUp: false
  };
  refreshLayout = () => {
    this.dialog && this.dialog.refreshLayout();
  };
  render() {
    let content = this.props.children, contentStyle = null;
    if (React.Children.count(content) === 1) {
      content = React.Children.only(content);
      if (typeof content === 'string') {
        content = (<JDText style={styles.contentText}>{content}</JDText>);
        contentStyle = {
          padding: 50,
          paddingTop: 94,
          paddingBottom: 76
        };
      }
    }
    return (
      <JDDialog
        show={this.props.show}
        ref={(v) => this.dialog = v}
        onClose={this.props.onClose}
        overlayStyle={this.props.overlayStyle}
        dialogStyle={this.props.dialogStyle}
        onFocusUp={this.props.onFocusUp}
        onDismiss={this.props.onDismiss}
        dismiss={this.props.dismiss}
        onRequestClose={this.props.onRequestClose}
        overlayClickable={this.props.overlayClickable}>
        <View style={styles.dialogInner}>
          <View style={[styles.content, contentStyle]}>
            {content}
          </View>
          <View style={styles.actionGroup}>
            <JDTouchable style={[styles.btn, styles.cancelBtn, this.props.cancelStyle]} onPress={this._onCancel} underlayColor={this.props.cancelUnderlayColor}>
              <JDText style={styles.cancelText}>{this.props.cancelText}</JDText>
            </JDTouchable>
          </View>
        </View>
      </JDDialog>
    );
  }

  _onCancel = () => {
    if (this.props.onCancel) {
      this.props.onCancel();
      return;
    }
    this.props.onClose && this.props.onClose();
  };

  _onConfirm = () => {
    this.props.onConfirm && this.props.onConfirm();
  };
}

const styles = StyleSheet.create({
  dialogInner: {
    justifyContent: 'space-between',
    //flex: 1
  },
  content: {
    justifyContent: 'center',
    alignItems: 'center'
  },
  contentText: {
    color: '#232326',
  },
  actionGroup: {
    flexDirection: 'row',
    borderTopWidth: JDDevice.getDpx(1),
    borderTopColor: '#E3E5E9'
  },
  btn: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    height: 40
  },
  cancelBtn: {
    backgroundColor: '#F23030',
    borderBottomLeftRadius: Platform.OS==='ios'?6:8,
    borderBottomRightRadius: Platform.OS==='ios'?6:8,
  },
  cancelText: {
    color: '#FFF'
  },
});

module.exports = JDConfirmDialog;
